import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
   "inline-flex items-center justify-center font-archivo disabled:opacity-50 disabled:pointer-events-none rounded-[2.5rem] transition-colors",
   {
      variants: {
         variant: {
            // LARGE WHITE
            "l-white": [
               "bg-custom-dark text-d-body-l-paragraph text-custom-white  px-[1.75rem] py-[0.625rem]",
               "hover:bg-custom-blue hover:text-custom-white transition-colors duration-300",
            ].join(" "),
            // MEDIUM WHITE
            "m-white": [
               "bg-custom-dark text-d-body-m-line text-custom-white  px-[1.25rem] py-[0.625rem]",
               "hover:bg-custom-blue hover:text-custom-white transition-colors duration-300",
            ].join(" "),
            // TAB WHITE
            "tab-white": [
               "bg-custom-grey text-custom-dark text-d-body-m-line px-[1.25rem] py-[0.625rem]",
               "hover:bg-custom-dark/10 transition-colors duration-300",
            ].join(" "),
            "tab-white-selected":
               "bg-custom-blue text-d-body-m-line  text-custom-white px-[1.25rem] py-[0.625rem]",
            // SMALL TAB
            "stab-white": [
               "bg-custom-grey text-custom-dark text-d-body-s-line px-[1.25rem] py-[0.625rem]",
               "hover:bg-custom-dark/10 transition-colors duration-300",
            ].join(" "),
            "stab-white-selected":
               "bg-custom-blue text-custom-white text-d-body-s-line px-[1.25rem] py-[0.625rem]",
            // LARGE DARK
            "l-dark": [
               "bg-custom-white text-d-body-l-paragraph text-custom-dark  px-[1.75rem] py-[0.625rem]",
               "hover:bg-custom-light-blue hover:text-custom-dark transition-colors duration-300",
            ].join(" "),
         },
      },
      defaultVariants: {
         variant: "l-white",
      },
   }
);

export interface ButtonProps
   extends React.ButtonHTMLAttributes<HTMLButtonElement>,
      VariantProps<typeof buttonVariants> {
   asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
   ({ className, variant, asChild = false, ...props }, ref) => {
      const Comp = asChild ? Slot : "button";
      return (
         <Comp
            className={cn(buttonVariants({ variant, className }))}
            ref={ref}
            {...props}
         />
      );
   }
);
Button.displayName = "Button";

export { Button, buttonVariants };
